import React from 'react';
import classes from '../List.module.scss';

type SearchableListBodyProps = {
  maxHeight?: number;
};
const SearchableListBody: React.FC<SearchableListBodyProps> = ({
  maxHeight,
  children
}) => {
  const maxHeightValue = maxHeight ? `${maxHeight}px` : 'none';

  return (
    <div
      className={classes.searchableResultContainer}
      style={
        {
          '--container-max-height': maxHeightValue
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
};

export default SearchableListBody;
